import React from 'react';

const STAGE_STYLES = {
  prospect:    { label: 'Prospect',    bg: 'var(--s-w07)', color: 'var(--s-muted)' },
  assessed:    { label: 'Assessed',    bg: 'rgba(255,176,46,0.12)',  color: 'var(--s-amber)' },
  shortlisted: { label: 'Shortlist',   bg: 'rgba(61,220,132,0.12)',  color: 'var(--s-green)' },
  approved:    { label: 'Approved',    bg: 'rgba(61,220,132,0.12)',  color: 'var(--s-green)' },
  rejected:    { label: 'Rejected',    bg: 'rgba(255,93,93,0.12)',   color: 'var(--s-red)' },
};

function scoreColor(s) {
  if (s == null) return 'var(--s-muted)';
  if (s >= 70) return 'var(--s-green)';
  if (s >= 55) return 'var(--s-amber)';
  return 'var(--s-red)';
}

export default function Rail({ sites, selectedId, onSelect, onSave, canSave, onOpenPipeline }) {
  return (
    <aside className="sq-glass" style={styles.rail}>
      <div style={styles.head}>
        <h2 style={styles.h2}>Pipeline</h2>
        <button onClick={onOpenPipeline} style={styles.manage}>Manage →</button>
      </div>
      <div style={styles.list}>
        {(!sites || sites.length === 0) && (
          <div style={styles.empty}>
            No saved sites yet — drop a pin and save it to start a pipeline.
          </div>
        )}
        {(sites || []).map(s => {
          const stage = STAGE_STYLES[s.stage] || STAGE_STYLES.prospect;
          const score = s.latest_score ?? s.last_score ?? null;
          return (
            <div
              key={s.id}
              onClick={() => onSelect(s)}
              style={{
                ...styles.site,
                ...(String(s.id) === String(selectedId) ? styles.siteSel : {}),
              }}
            >
              <div style={{ ...styles.score, color: scoreColor(score) }}>
                {score != null ? score : '—'}
              </div>
              <div style={styles.meta}>
                <div style={styles.name}>{s.name}</div>
                <span style={{ ...styles.stage, background: stage.bg, color: stage.color }}>
                  {stage.label}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      <div style={styles.foot}>
        <button
          className="sq-btn primary"
          style={{ width: '100%' }}
          onClick={onSave}
          disabled={!canSave}
        >
          ＋ Save current site
        </button>
      </div>
    </aside>
  );
}

const styles = {
  rail: {
    position: 'fixed',
    left: 18,
    top: 84,
    bottom: 18,
    width: 264,
    zIndex: 15,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  head: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 16px 10px',
  },
  h2: {
    font: '600 11px var(--s-sans)',
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: 'var(--s-muted)',
  },
  manage: {
    appearance: 'none',
    border: 'none',
    background: 'transparent',
    color: 'var(--s-faint)',
    font: '600 11px var(--s-sans)',
    cursor: 'pointer',
  },
  list: { flex: 1, overflowY: 'auto', padding: '0 8px 8px' },
  empty: {
    fontSize: 12,
    color: 'var(--s-faint)',
    padding: '14px 10px',
    lineHeight: 1.6,
  },
  site: {
    display: 'flex',
    alignItems: 'center',
    gap: 11,
    padding: '10px 10px',
    borderRadius: 10,
    cursor: 'pointer',
    border: '1px solid transparent',
  },
  siteSel: {
    background: 'rgba(255,106,61,0.09)',
    borderColor: 'rgba(255,106,61,0.25)',
  },
  score: {
    width: 38,
    height: 38,
    borderRadius: 10,
    flexShrink: 0,
    display: 'grid',
    placeItems: 'center',
    font: '700 14px var(--s-mono)',
    background: 'var(--s-w06)',
  },
  meta: { minWidth: 0, flex: 1 },
  name: {
    fontWeight: 600,
    fontSize: 13,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: 'var(--s-text)',
  },
  stage: {
    display: 'inline-block',
    font: '600 9.5px var(--s-sans)',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    padding: '2px 7px',
    borderRadius: 99,
    marginTop: 3,
  },
  foot: { padding: 10, borderTop: '1px solid var(--s-line2)' },
};
